// extracted by mini-css-extract-plugin
module.exports = {"wrap":"kv-module--wrap--2T_c2","siteHeading":"kv-module--site-heading--2xfIW","content":"kv-module--content--6J_Uw","overlay":"kv-module--overlay--2EQio"};